import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import BookingPage from "@/pages/BookingPage";
import RentalsPage from "@/pages/RentalsPage";
import GalleryPage from "@/pages/GalleryPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import PhotographerLoginPage from "@/pages/PhotographerLoginPage";
import PhotographerDashboard from "@/pages/PhotographerDashboard";
import BookingSuccessPage from "@/pages/BookingSuccessPage";
import MemberDashboard from "@/pages/MemberDashboard";
import AuthCallback from "@/pages/AuthCallback";

// Context
import { AuthProvider } from "@/context/AuthContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Seed snakes on first load
const seedSnakes = async () => {
  try {
    const response = await fetch(`${API}/snakes`);
    const snakes = await response.json();
    if (snakes.length === 0) {
      await fetch(`${API}/seed-snakes`, { method: 'POST' });
    }
  } catch (e) {
    console.error('Error seeding snakes:', e);
  }
};

function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id (OAuth callback)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/booking" element={<BookingPage />} />
      <Route path="/booking/success" element={<BookingSuccessPage />} />
      <Route path="/booking/:bookingId" element={<BookingPage />} />
      <Route path="/rentals" element={<RentalsPage />} />
      <Route path="/gallery" element={<GalleryPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/photographer/login" element={<PhotographerLoginPage />} />
      <Route path="/photographer/dashboard" element={<PhotographerDashboard />} />
      <Route path="/dashboard" element={<MemberDashboard />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    seedSnakes();
  }, []);

  return (
    <AuthProvider>
      <div className="App min-h-screen bg-background">
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </AuthProvider>
  );
}

export default App;
